import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/AncillaryDistribution/EditorData";

const updateAncillaryDistributionEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_DATA_FETCHED:
      return { ...state, ancillaryDistributionEditorData: action.data };
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_DATA_COPIED:
      return { ...state, ancillaryDistributionEditorData: { ...action.data} };
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_DATA_UPDATED:
      return { ...state, ancillaryDistributionEditorData: { ...state.ancillaryDistributionEditorData, ...action.data } };
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.ANCILLARY_DISTRIBUTION_EDITOR_SET_BOUND_ITEM:
      return {...state, ancillaryDistributionEditorData: {...state.ancillaryDistributionEditorData, ...action.data}}
    default:
      return state;
  }
};

export default updateAncillaryDistributionEditorData;
